import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Checkbox } from '@telus-uds/components-web';

import { ServiceNameContainer, Td } from './css';
import RatePlanTableSubRow from './rateplanTableSubRow';

import { iotGeotabFleetTrackerOEM } from '../../../../utils/constant';
import FieldGuide from '../../../../form/fields/common/fieldGuide';

const RatePlanTableRow = ({
  hardware,
  orderType,
  productSelected,
  accountType,
  corporateType,
  rowData,
  viewType,
  ratePlans,
  setRatePlans,
  isSubmitting,
  setGeoTabNewPriceValid,
  setHardware
}) => {
  const {
    fields: {
      rateplanName,
      toolTip,
      show50PercentUsCheckBox,
      checkboxLabel,
      deviceList,
      rateplanType
    }
  } = rowData;
  const rowSpanCount = deviceList.length;
  const is50PercntUSCheckBoxVisible =
    show50PercentUsCheckBox && viewType === 'advancedView';

  const [fiftyPercentInUS, setFiftyPercentInUS] = useState(() =>
    Object.keys(_.get(ratePlans, rateplanName, {})).some(deviceName =>
      _.get(ratePlans, `${rateplanName}.${deviceName}.fiftyPercentInUS`, false)
    )
  );
  const rowRef = useRef(false);

  useEffect(() => {
    if (viewType && rowRef.current) setFiftyPercentInUS(false);
    rowRef.current = true;
  }, [viewType]);

  return (
    <>
      {deviceList.map((deviceData, index) => (
        <tr key={_.get(deviceData, 'sys.id')}>
          {index === 0 && (
            <Td
              rowSpan={rowSpanCount}
              style={{
                paddingTop: rateplanName === iotGeotabFleetTrackerOEM ? 40 : '',
                verticalAlign:
                  rateplanName === iotGeotabFleetTrackerOEM ? 'top' : 'center',
                background: '#f7f7f7',
                fontWeight: '700'
              }}
            >
              <ServiceNameContainer>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
                  <p>{rateplanName}</p>
                  {toolTip && (
                    <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                      <FieldGuide isRichText tooltip={toolTip} />
                    </div>
                  )}
                </div>
                {is50PercntUSCheckBoxVisible && (
                  <div
                    key={`${rateplanName}-fiftyPercentInUS`}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      transform: 'scale(0.85)',
                      transformOrigin: 'center center',
                      maxWidth: '100%'
                    }}
                  >
                    <Checkbox
                      label={checkboxLabel}
                      name={`${rateplanName}-fiftyPercentInUS`}
                      value={`${rateplanName}-fiftyPercentInUS`}
                      onChange={() => setFiftyPercentInUS(!fiftyPercentInUS)}
                      checked={fiftyPercentInUS}
                    />
                  </div>
                )}
              </ServiceNameContainer>
            </Td>
          )}
          <RatePlanTableSubRow
            hardware={hardware}
            orderType={orderType}
            productSelected={productSelected}
            accountType={accountType}
            corporateType={corporateType}
            rateplanName={rateplanName}
            deviceData={deviceData}
            index={index}
            fiftyPercentInUS={fiftyPercentInUS}
            viewType={viewType}
            ratePlans={ratePlans}
            setRatePlans={setRatePlans}
            rateplanType={rateplanType}
            isSubmitting={isSubmitting}
            setGeoTabNewPriceValid={setGeoTabNewPriceValid}
            setHardware={setHardware}
          />
        </tr>
      ))}
    </>
  );
};

RatePlanTableRow.propTypes = {
  hardware: PropTypes.shape({}).isRequired,
  orderType: PropTypes.string.isRequired,
  productSelected: PropTypes.string.isRequired,
  accountType: PropTypes.string.isRequired,
  corporateType: PropTypes.string,
  rowData: PropTypes.shape({
    fields: PropTypes.shape({
      rateplanName: PropTypes.string,
      show50PercentUsCheckBox: PropTypes.bool,
      checkboxLabel: PropTypes.string,
      rateplanType: PropTypes.string,
      toolTip: PropTypes.string,
      deviceList: PropTypes.arrayOf(
        PropTypes.shape({
          deviceName: PropTypes.string,
          terms: PropTypes.arrayOf(
            PropTypes.shape({
              termName: PropTypes.string,
              termPrice: PropTypes.number,
              termPrice50PrecentUs: PropTypes.number
            })
          )
        })
      )
    })
  }).isRequired,
  viewType: PropTypes.string.isRequired,
  ratePlans: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setRatePlans: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired
};

export default RatePlanTableRow;
